<script setup>
    const props = defineProps({
        branch: String
    })
</script>

<template>
    <div class="invitation__branch">
        <div class="form_header">
            {{ $t("field.branch") }}
        </div>
        <div class="form_description">
            <span class="invitation__description_input">
                {{ branch }}
            </span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.invitation__branch {
    display: flex;
    flex-direction: column;
    max-width: 250px !important;
    overflow-wrap: break-word;
    
    // padding-bottom: 5px;
}
.form_header {
    
}
.form_description {
    flex: 4;
}

@media (max-width: 576px) {
    .invitation__branch{
        flex-direction: column;
        gap: 0em;
        
    }
    .form_description {
        padding-left: 0px;
        flex: 4;
    }
}
</style>